<script setup lang="ts">

const props = withDefaults(defineProps<{
  item: {
    slug: string
    title: string
    description: string
    image: string
    category: string
    new: boolean
    cardImgObjPosition: string
  }
}>(), {
  item: () => {
    return {
      slug: "blog-slug",
      title: "Blog title",
      description: "Blog description",
      image: "/images/12.jpg",
      cardImgObjPosition: 'center center',
      category: "Insights",
      new: true,
    }
  },
})

const emit = defineEmits<{
	(e: 'redirect', path: string): void
}>()

function redirect(slug: string) {
  emit('redirect', slug)
}

const excerpt = computed(() => {
	const words = props.item.description.split(' ').slice(0, 20);
	return words.join(' ') + (words.length === 20 ? '...' : '');
})

const cardImgObjPosition = computed(() => {
  return props.item?.cardImgObjPosition ? props.item.cardImgObjPosition : 'center center'
})

const image = computed(() => {
  return `/images/blog/${props.item.slug}/${props.item.image}`
})

</script>

<template>
	<div class="nav-blog-card">

		<div class="inner card">

			<div class="sec-image">
				<div class="sec-tags">
					<div class="tag">New</div>
				</div>
				<div class="sec-category">
					<div class="category">Blog</div>
				</div>
				<div class="inner">
					<img
            :src="image"
            alt=""
            class="object-cover object-center w-full h-full"
            :style="{ objectPosition: cardImgObjPosition }"
          />
				</div>
			</div>

			<div class="sec-content">

				<div class="sec-title">
					<a @click="redirect(item.slug)" class="title font-heading">
						{{item.title}}
					</a>
				</div>
				<!-- <div class="sec-meta">
					<div class="meta">
						<span class="date">June 12, 2021</span>
					</div>
				</div> -->
				<div class="sec-description">
					<div>
						{{item.description}}
					</div>
				</div>
				<div class="sec-actions">
					<div class="action">
						<a @click="redirect(item.slug)" class="card-link">

						<div class="sec-label">
							Read more
						</div>
						<div class="sec-icon">

							<i class="i i-mdi:arrow-right"></i>

						</div>

						</a>
					</div>
				</div>
			</div>

		</div>

	</div>
</template>

<style lang="scss">
.nav-blog-card {
	width: 100%;

	transform: scale(0.99);
	transition: all 0.2s ease;



	>.inner {
		width: 100%;
		margin: 0 auto;
		// @apply shadow-xl;
		display: flex;
		align-items: center;
		justify-content: center;

		color: white;

		// @include mq($until: t) {
		//     max-width:440px;
		// }
		max-width: 440px;

		&.card {
			// @apply shadow-lg;

			background: white;
			display: grid;
			@apply rounded-2xl;
			overflow: hidden;
			max-width:90%;
			margin: 0 auto;

			// box-shadow: rgba(0, 0, 0, .04) 0 1px 0, rgba(0, 0, 0, .05) 0 2px 7px, rgba(0, 0, 0, .06) 0 12px 22px;
			// @apply shadow-2xl;
			// @apply shadow-sm;
			border: 1px solid var(--gray-100);

			>.sec-image {
				width: 100%;
				height: 150px;
				position: relative;
				overflow: hidden;


				.sec-tags {
					position: absolute;
					top: 0;
					left: gr(0.5);
					top: gr(0.5);
					z-index: 1;

					.tag {
						font-weight: 500;
						border-radius: gr(0.5);
						padding: gr(0.1) gr(0.4);
						font-size: fs(-2.5);
						font-weight: 600;
						color: white;
						background: transparent;
						box-shadow: inset 0 0 0 1px white;

					}
				}

				.sec-category {
					position: absolute;
					right: 0;
					bottom: 0;
					z-index: 1;
					background: white;
					height: gr(0.7);
					border-radius: 0.25rem 0 0 0;
					overflow: hidden;

					>.category {
						padding: 0 gr(0.66);
						font-size: fs(-2);
						font-weight: 400;
						color: var(--blue-500);
						background: white;
						box-shadow: inset 0 0 0 1px white;
						transform: translateY(1px);
					}
				}

				>.inner {
					width: 100%;
					height: 100%;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						transition: 0.4s ease;
					}
				}
			}

			>.sec-content {
				max-width: calc(100% - gr(1.75));
				margin: 0 auto;
				padding: gr(0.75) 0;
				display: grid;
				gap: gr(0.75);

				>.sec-title {
					width: 100%;

					a {
						font-weight: bold;
					}

					>.title {
						font-size: fs(1);

						color: var(--base-700);
						font-weight: 500;
						max-width: 90%;
						line-height: gr(1);
						cursor: pointer;

						&:hover {
							color: var(--blue-500);
							text-decoration: none;
						}
					}
				}

				>.sec-meta {
					width: 100%;
					display: none;

					>.meta {
						font-size: fs(-1);
						color: var(--base-600);
						font-weight: 400;

						>span {
							font-size: fs(-1);
						}
					}
				}

				>.sec-description {
					width: 100%;

					>div {
						font-size: fs(-1);
						color: var(--base-600);
						font-weight: 400;
					}
				}

				>.sec-actions {
					display: flex;
					justify-content: flex-end;

					>.action {
						.card-link {
              display: flex;
              gap: gr(0.20);

              position: relative;

              padding: gr(0.2) gr(0.5);
              cursor: pointer;
              border-radius: gr(0.25);

              // box-shadow: inset 0 0 0 1px var(--gray-200);

              *{
                transition: all 0.2s ease;
              }

              >.sec-label {
                font-size: fs(-1);
                font-weight: 500;
                color: var(--base-600);
              }

              >.sec-icon {
                width: gr(1);
                height: gr(1);

                display: flex;
                align-items: center;
                justify-content: center;

                i {
                  font-size: fs(-1.5);
                  color: var(--base-500);
                }
              }

              &:hover {
                text-decoration: none;

                // box-shadow: inset 0 0 0 1px var(--c-sky-blue);
                transform: translateY(-1px);
                >.sec-label {
                  color: var(--c-sky-blue);
                  padding-right: gr(0.1125);
                }
                >.sec-icon {
                  i {
                    color: var(--blue-700);
                    transform: scale(1.1);
                  }
                }
                &:active {
                  transform: translateY(0);
                }
              }
            }
					}
				}
			}

			&:hover {
				cursor: grab;
				transition: all 0.2s ease;
				// @apply shadow;

				.sec-image {
					>.sec-tags {}

					>.inner {
						img {
							transform: scale(1.1);
						}
					}
				}

				.sec-content {
					.sec-title {
						.title {
							color: var(--base-900);
						}
					}

					.sec-meta {
						.meta {
							color: var(--base-600);
						}
					}

					.sec-description {
						>div {
							color: var(--base-800);
						}
					}

					.sec-actions {
						.action {
							button {
								color: var(--base-900);
								gap: gr(0.75);

								.sec-label {
									color: var(--blue-650);
								}

								.sec-icon {
									i {
										// color: red;
									}
								}
							}
						}
					}
				}
			}

		}
	}

	&:hover {

		transform: scale(1);

		>.inner {
			&.card {
				// @apply shadow-xl;
			}
		}
	}
}
</style>